import {createSlice} from "@reduxjs/toolkit";


const faqSlice = createSlice({
    name: "student",
    initialState: [
    {
        id: 0,
        question: "Как провести урок через платформу?",
        answer: "Откройте нужный урок в SPEAKID и включите демонстрацию экрана в удобном для вас приложении для онлайн-занятий. Ученик будет видеть весь материал вместе с вами.",
        active: true,
    },
    {
        id: 1,
        question: "Нужно ли регистрировать ученика на платформе?",
        answer: "Нет. Доступ к платформе есть только у преподавателя. Ученик ничего не устанавливает и не заходит в личный кабинет.",
        active: false,
    },
    {
        id: 2,
        question: "С какого урока начать заниматься с учеником?",
        answer: "Определите уровень ученика самостоятельно и укажите его уровень в карточке ученика. Программа подтянется к ученику автоматически, исходя из установленного вами уровня языка для этого студента.",
        active: false,
    },
    {
        id: 3,
        question: "Где я могу найти пройденные уроки?",
        answer: "История занятий и программа доступна в карточке ученика, в неё можно попасть через раздел «Журнал учеников». В карточке ученика можно посмотреть, какие уроки уже проведены и какие темы изучались.",
        active: false,
    },
    {
        id: 4,
        question: "Я переехал в другую страну. Как изменить часовой пояс?",
        answer: "Платформа предложит вам адаптацию расписания под новый часовой пояс автоматически. Если этого не произошло, выберите новый часовой пояс вручную. Зайдите в раздел «Личный кабинет» → «Изменить профиль», затем в графе «Часовой пояс» выберите нужный часовой пояс и сохраните.",
        active: false,
    },
    {
        id: 5,
        question: "У меня завис урок или перестал работать один из слайдов. Что делать?",
        answer: "Просто обновите страницу, урок должен открыться в том месте, где вы остановились. Если не помогло - очистите кеш в браузере или попробуйте другой браузер (лучше всего работает в Chrome, мы рекомендуем использовать именно его).",
        active: false,
    },
    {
        id: 6,
        question: "Как удалить урок из расписания, если ученик не придёт?",
        answer: "Зайдите в раздел «Моё расписание», выберите нужный урок и нажмите «Изменить урок». Там вы можете удалить занятие со списанием оплаты с баланса ученика или без него - в зависимости от ваших договорённостей с родителями.",
        active: false,
    },
    {
        id: 7,
        question: "Что такое баланс ученика?",
        answer: "Баланс ученика это сумма, которую вам переводят заранее (предоплата или стоимость абонемента). Вы вручную пополняете баланс при получении оплаты, а затем назначаете стоимость одного занятия. После проведения урока эта сумма списывается с баланса ученика и автоматически зачисляется на ваш баланс - так вы отслеживаете поступления и доходы, а также всегда знаете, кому нужно напомнить об оплате, когда баланс кончается.",
        active: false,
    },
    

],
    reducers: {
        changeActive: (state, action) => {
            return [...JSON.parse(JSON.stringify(state)).map(el=>{
                el.active = el.id === action.payload;
                return el
            })]
        }
    },

});


export const {changeActive} = faqSlice.actions
export default faqSlice.reducer;